var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevenLogo = function SvgElevenLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#elevenLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.44 8.718h-5.418v2.492h4.803v1.507h-4.803v2.571h5.481v1.5h-7.166V7.209h7.104v1.509M47.33 7.21h1.688v8.05h5.034v1.531h-6.724V7.212zM66.483 8.718h-5.419v2.492h4.803v1.507h-4.803v2.571h5.487v1.5H59.38V7.209h7.104v1.509M79.186 7.179h1.823l-3.978 9.644h-1.476L71.568 7.18h1.867l2.88 7.36zM92.978 8.718h-5.419v2.492h4.806v1.507h-4.806v2.571h5.49v1.5h-7.168V7.209h7.095v1.508zM105.588 7.21h1.654v9.58h-1.406l-5.277-6.802v6.802h-1.66V7.21h1.561l5.128 6.633zM19.033 17.725l5.725-5.723-5.48-5.484zM14.332 1.571 12.759 0 .758 12.002l4.673 4.67zM17.021 4.262l-1.599-1.598-5.99 18.008L12.759 24l1.217-1.214z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "elevenLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.758 0h106.484v24H.758z"
  })))));
};
export default SvgElevenLogo;